import React, { ChangeEvent, useState, FC } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { STATUS } from "../../utils/const"
import { StatusInfo } from "../UpdateStoksIcon/StatusInfo/StatusInfo"
import { StorageSelectControl } from "../StorageSelect/StorageSelectControl"
import { MARKETPLACE } from "@acc/shared"
import { LogButton } from "../LogButton/LogButton"
import { Modal } from "../../features/Modal/Modal"
import { StocksTable } from "../ObjectViewer/ObjectTableViewer"
import { getMessage } from "../../msgs/msgs"
import { ObjectRenderer } from "../ObjectViewer/ObjectViewer"
import { selectOrdersStore } from "../../app/reducers/ordersReducer"
import {
  deleteFeedShopWbRecode,
  feedShopWbUpdateStocks,
  selectFeedShopsStore,
  uploadFeedShopWbRecode,
} from "../../app/reducers/feedShopsSlice"
import BaseApi from "../../api/api"
import { Tip, TipType } from "../Tip/Tip"
import { parseWbRecode } from "./recode"
import { getCustomArgs } from "./CustomShopComponents/CustomShopComponents"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { Checkbox, Button, Flex, Text } from "@radix-ui/themes"
import { getWbRecode } from "../../app/reducers/shopsSlice"
import { formXlsxFromFlatArray } from "../../utils/formXlsxFromFlatArray"

const resetStocks = async (selectedStorageId: string, ident: string) => {
  const response = await BaseApi.resetWbStocks(selectedStorageId, ident)
  if (response.data) {
    NotificationService.showNotification({
      message: response.data.message,
      level: (response.data.success && "success") || "error",
    })
  }
}

export const FeedShop: FC<{ ident: string }> = ({ ident }) => {
  const dispatch = useAppDispatch()

  const ordersStore = useAppSelector(selectOrdersStore)
  const { [ident]: feedShopStore } = useAppSelector(selectFeedShopsStore)

  const { storages } = ordersStore

  const [selectedStorageId, setSelectedStorages] = useState("")
  const [isOpenModalUpdatePrices, setOpenModalUpdatePrices] = useState(false)
  const [isOpenModalResetStocks, setOpenModalResetStocks] = useState(false)
  const [updatePrices, setUpdatePrices] = useState(false)
  const [updateStocks, setUpdateStocks] = useState(false)
  const [isOpenErrModal, setOpenErrModal] = useState(false)
  const [customArgs, setCustomArgs] = useState<{ [key: string]: boolean }>({})
  const [isReturnToPromo, setReturnToPromo] = useState(false)
  const isPromotionDataUploaded = false

  const CustomArgsComponent = getCustomArgs(ident)

  const {
    lastStocksUpdated,
    lastPricesUpdated,
    status,
    isExistRecode,
    errors,
    calcIdent,
  } = feedShopStore || {}

  const handleUpdate = () => {
    if (
      (updatePrices || updateStocks || isReturnToPromo) &&
      isExistRecode &&
      selectedStorageId &&
      (isReturnToPromo ? isPromotionDataUploaded : true)
    ) {
      setOpenModalUpdatePrices(true)
    }
  }

  const onResetClick = () => {
    if (isExistRecode && selectedStorageId) {
      setOpenModalResetStocks(true)
    }
  }

  return (
    <div className="flex flex-column flex-align-center flex-justify-center gap-10">
      <div>
        {status && (
          <h6>
            статус: <StatusInfo status={status} />
          </h6>
        )}
        {(errors?.length && (
          <div className="flex gap-20">
            <StatusInfo
              status={STATUS.WARN}
              value="При обновлении были пропущены ошибки"
            />
            <Button onClick={() => setOpenErrModal(true)} color="red">
              посмотреть ошибки
            </Button>
          </div>
        )) ||
          null}
      </div>
      {lastPricesUpdated && (
        <b>
          Последнее обновление цен:{" "}
          {new Date(lastPricesUpdated).toLocaleString()}
        </b>
      )}
      {lastStocksUpdated && (
        <b>
          Последнее обновление остатков:{" "}
          {new Date(lastStocksUpdated).toLocaleString()}
        </b>
      )}

      <div className="flex gap-20 w100 flex-justify-center flex-align-center">
        {isExistRecode ? (
          <Flex direction="column" gap="2">
            <Button
              onClick={() => {
                dispatch(deleteFeedShopWbRecode(ident))
              }}
            >
              Удалить файл перекодировки
            </Button>

            <Button
              onClick={() => {
                getWbRecode(ident).then((rows) => {
                  formXlsxFromFlatArray(`${ident}_recode`, rows)
                })
              }}
            >
              Скачать перекодировку
            </Button>
          </Flex>
        ) : (
          <div className="flex flex-column">
            <Button asChild>
              <label htmlFor={`${ident}-recode-file`}>
                Загрузить файл перекодировки
                <input
                  style={{ display: "none" }}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const file = e.target.files?.[0]
                    if (file) {
                      parseWbRecode(file).then((recode) => {
                        dispatch(
                          uploadFeedShopWbRecode({
                            shopIdent: ident,
                            rows: recode,
                          }),
                        )
                      })
                    }
                  }}
                  type="file"
                  accept=".xlsx"
                  id={`${ident}-recode-file`}
                />
              </label>
            </Button>
          </div>
        )}
        <FeedShopTip withSizes={["with_sizes_1"].includes(calcIdent || "")} />
      </div>

      <StorageSelectControl
        label="Склад для обновления"
        value={selectedStorageId}
        onChange={(value) => {
          setSelectedStorages(value)
        }}
        controlKey="storages-select"
        marketplace={MARKETPLACE.WB}
      />

      <div className="flex flex-justify-center gap-10">
        <label>
          <Checkbox
            checked={updatePrices}
            onCheckedChange={(value) => setUpdatePrices(value === true)}
          />
          Обновить цены
        </label>
        <label>
          <Checkbox
            checked={updateStocks}
            onCheckedChange={(value) => setUpdateStocks(value === true)}
          />
          Обновить остатки
        </label>
        <label>
          <Checkbox
            checked={isReturnToPromo}
            onCheckedChange={(value) => setReturnToPromo(value === true)}
          />
          Вернуть в акцию
        </label>
        {CustomArgsComponent && (
          <CustomArgsComponent values={customArgs} setValue={setCustomArgs} />
        )}
      </div>

      <div className="flex flex-justify-center gap-10">
        <Button
          disabled={
            !isExistRecode ||
            !selectedStorageId ||
            (!updatePrices && !updateStocks && !isReturnToPromo)
          }
          onClick={handleUpdate}
        >
          Обновить
        </Button>
        <Button
          disabled={!isExistRecode || !selectedStorageId}
          onClick={onResetClick}
        >
          Сбросить остатки на складе
        </Button>
        <LogButton getData={() => getLogData(ident)} />
      </div>

      <Modal
        isOpen={isOpenModalUpdatePrices}
        header={`Подтвердите действие. Обновление на ${ident}`}
        content={`Обновить ${updatePrices ? "цены" : ""} ${
          updatePrices && updateStocks ? "и" : ""
        } ${updateStocks ? "остатки" : ""} для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.name
        }`}
        onClose={() => setOpenModalUpdatePrices(false)}
        onOk={() => {
          selectedStorageId &&
            dispatch(
              feedShopWbUpdateStocks({
                shopIdent: ident,
                selectedStorageId,
                updatePrices,
                updateStocks,
                customArgs,
                isReturnToPromo,
              }),
            )
          setOpenModalUpdatePrices(false)
        }}
      />
      <Modal
        isOpen={isOpenModalResetStocks}
        header="Подтвердите действие. Сбросить остатки"
        content={`Сбросить остатки для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.name
        }`}
        onClose={() => setOpenModalResetStocks(false)}
        onOk={() => {
          selectedStorageId && resetStocks(selectedStorageId, ident)
          setOpenModalResetStocks(false)
        }}
      />
      <Modal
        isOpen={isOpenErrModal}
        header="Ошибки пропущенные при обновлении"
        onClose={() => setOpenErrModal(false)}
        onOk={() => setOpenErrModal(false)}
        size="auto"
        content={
          <div className="flex flex-column gap-20">
            {errors?.map((el) => {
              if (el.type === "UPLOAD_STOCKS") {
                return <StocksTable data={el} />
              }
              return (
                <div className="flex gap-20">
                  <b>{getMessage(el.type)}</b>
                  <ObjectRenderer data={el.errors} />
                </div>
              )
            })}
          </div>
        }
      ></Modal>
    </div>
  )
}

export const FeedShopTip: FC<{ withSizes?: boolean }> = ({
  withSizes = false,
}) => {
  return (
    <Tip
      type={TipType.WARNING}
      content={
        <span>
          <b>Внимание! </b>
          <p>
            Файл перекодировки должен быть формата <b> XLSX </b> и содержать
            следующие <b> обязательные </b> колонки:
          </p>
          <ol style={{ textAlign: "left" }}>
            <li>
              <b>article </b> - артикул товара с магазина
            </li>
            <li>
              <b>GoodCode </b> - артикул продавца с WB
            </li>
            <li>
              <b>nmId </b> - артикул ВБ
            </li>
            <li>
              <b>sku </b> - баркод с WB
            </li>
            <li>
              <b>count </b> - количество товаров продаваемых в карточке
              (кратность)
            </li>
            {withSizes && (
              <li>
                <b>sizes </b> - размеры упаковки, в см. В формате: "10;10;10";
              </li>
            )}
            <li>
              <b>commission </b> - комиссия. Если не заполнено, то будет
              использовано значение из параметра цен
            </li>
          </ol>
        </span>
      }
    />
  )
}

const getLogData = async (shop: string) => {
  return BaseApi.logByShopIdent(shop).then((res) => {
    if (res.success) return res.data
    return []
  })
}
